import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name sun-moon
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xMyA4LjEyOUE0IDQgMCAwIDEgMTUuODczIDExIiAvPgogIDxwYXRoIGQ9Im0xOSA1LTEuMjU2IDEuMjU2IiAvPgogIDxwYXRoIGQ9Ik0yMCAxMmgyIiAvPgogIDxwYXRoIGQ9Ik05IDhhNSA1IDAgMSAwIDcgNyA3IDcgMCAxIDEtNy03IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sun-moon
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SunMoon: IconNode = [
  ['path', { d: 'M12 2v2' }],
  ['path', { d: 'M13 8.129A4 4 0 0 1 15.873 11' }],
  ['path', { d: 'm19 5-1.256 1.256' }],
  ['path', { d: 'M20 12h2' }],
  ['path', { d: 'M9 8a5 5 0 1 0 7 7 7 7 0 1 1-7-7' }],
];

export default SunMoon;
